module.exports = __webpack_public_path__ + "static/images/callout_3.75e846cc900db2e46017f524afd0ca61.jpg";